<template>
  <div :id="id" :style="cstyle"></div>
</template>

<script>
import { randomCoding } from '@/util/tool'

export default {
  name: 'echarts',
  props: {
    id: {
      type: String,
      default: randomCoding(Math.ceil(Math.random() * 10))
    },
    options: {
      type: Object,
      default: () => {}
    },
    theme: {
      type: String,
      default: 'walden'
    },
    cstyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          minHeight: '360px'
        }
      }
    }
  },
  watch: {
    options: {
      handler (newVal) {
        this.initEcharts(newVal)
        return newVal
      },
      deep: true
    }
  },
  mounted () {
    this.initEcharts()
    window.onresize = () => {
      this.initEcharts()
    }
  },
  methods: {
    refresh () {
      this.initEcharts()
    },
    initEcharts () {
      const {
        id,
        theme,
        options
      } = this
      if (!options) return
      if (this.myChart && this.myChart.dispose) {
        this.myChart.dispose()
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(id), theme)
      // 绘制图表
      this.myChart.setOption(options, true)
    }
  }
}
</script>

<style scoped>

</style>
